import React, { FC } from 'react';

import { File as CustomFile } from '../../../generated/graphql';

import { AttachmentMode, AttachmentType } from '../../../models/attachment';

import { MessageCommon } from '../../../models/message';
import Attachment from '../Attachment';

import AttachmentListEmpty from './AttachmentListEmpty';

import { getShouldShowEmptyIllustration } from './helpers';
import * as Styled from './styled';

export type Props = {
  attachments: AttachmentType[];
  message?: MessageCommon;
  mode: AttachmentMode;
  requestFileRemove?: (key: CustomFile['key']) => void;
};

/**
 * List of attachments
 *
 * @param props                   Props passed to the component
 * @param props.attachments       Attachments to show
 * @param props.message           The message itself
 * @param props.mode              In which mode to render the component
 * @param props.requestFileRemove Callback for removing file from the array
 * @returns                       The component itself
 */
const AttachmentList: FC<Props> = ({
  attachments,
  message,
  mode,
  requestFileRemove,
}) => {
  const shouldSowEmptyIllustration = getShouldShowEmptyIllustration(
    mode,
    attachments.length,
  );

  if (shouldSowEmptyIllustration) {
    return <AttachmentListEmpty />;
  }

  return (
    <Styled.ListWrapper data-mode={mode}>
      {attachments.map(attachment => (
        <li key={attachment.key}>
          <Attachment
            attachment={attachment}
            message={message}
            mode={mode}
            requestFileRemove={requestFileRemove}
          />
        </li>
      ))}
    </Styled.ListWrapper>
  );
};

export default AttachmentList;
